import { accordionAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/unbound-method
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  accordionAnatomy.keys
)

export const Accordion = defineMultiStyleConfig({
  variants: {
    product: {
      button: {
        h: 8,
        px: 3,
        py: 1.5,
        bg: 'transparent',
        color: 'product.dark.bodySubtle',
        fontSize: 'sm',
        fontWeight: 'semibold',
        _hover: { bg: 'product.gray.50' },
        _focus: { bg: 'product.gray.50' },
        _active: {
          bg: 'product.blue.100',
        },
      },
      panel: {
        p: 0,
      },
      container: {
        border: 'initial',
        borderBottomWidth: 1,
        borderBottomColor: 'product.gray.100',
      },
    },
  },
  baseStyle: {
    container: {
      border: 'none',
    },
    button: {
      _hover: { bg: 'transparent' },
    },
  },
})
